export default __webpack_public_path__ + "static/media/slideCampaign-1.487f5086.png";